import React, { useEffect, useState } from 'react';

// MUI
import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const StyledFormControl = styled(FormControl)(({ disabled }) => ({
  width: '100%',
  ...(disabled && {
    '& .MuiFormControlLabel-label': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  }),
}));

const StyledRadio = styled(Radio)({
  padding: '4px 9px',
});

function RadioInput({ data }) {
  const {
    answers,
    column,
    rowIndex,
    columnIndex,
    updateValue,
    isReadOnly,
    isRS,
  } = data;
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    const currentValue = answers[rowIndex][columnIndex].calculatedValue;
    if (selectedValue !== currentValue) {
      setSelectedValue(currentValue || '');
    }
  }, [answers, rowIndex, columnIndex]);

  // For deleting a row in repeatable sections
  useEffect(() => {
    if (
      isRS &&
      selectedValue !== answers[rowIndex][columnIndex].calculatedValue
    ) {
      setSelectedValue(answers[rowIndex][columnIndex].calculatedValue || '');
    }
  }, [answers]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    updateValue(rowIndex, columnIndex, value, false);
  };

  return (
    <StyledFormControl disabled={isReadOnly}>
      <RadioGroup
        value={selectedValue}
        onChange={handleChange}
        id={`table-row-${rowIndex}-col-${columnIndex}`}
      >
        {column.options &&
          column.options.map((opt) => (
            <FormControlLabel
              key={opt.id}
              value={opt.value}
              control={<StyledRadio size="small" />}
              label={opt.label || opt.value}
            />
          ))}
      </RadioGroup>
    </StyledFormControl>
  );
}

export default RadioInput;
